module.exports = __webpack_public_path__ + "static/group-dcb402f12d05f6cab15bfaa940f7be94.jpg";